import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Popup from 'reactjs-popup'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import RSVP from 'srcReact/components/common2/RSVP'
import {
  convertUTCToTimezone,
  getCustomFormat1,
  getTimeFormat1,
  dateDiffInDays,
  formatLastUpdateDate,
  getDateFormat2,
  getDateFormat6,
  isToday,
  isTomorrow,
  getCustomDateFormat
} from 'srcReact/helpers/datetimeHelper'

const ViewMixrPopin = ({
  mixrId,
  title,
  description,
  picture,
  startDate,
  endDate,
  color,
  timezone,
  utcOffset,
  location,
  isRecurrence,
  isVisibility,
  attendance,
  isInvited,
  menuPortalTarget,
  userAttendance,
  showViewMixr,
  closeViewMixr,
  isMixrOver,
  handleClick,
  mixrRole,
  group,
  withoutGroupApproval
}) => {
  const { t } = useTranslation()
  useEffect(() => {
    if (showViewMixr) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [showViewMixr])

  // const getCustomDateFormat = (startDate, endDate, utcOffset) => {
  //   let customDateFormat = getCustomFormat1(startDate, utcOffset)
  //   const dtStartDate = new Date(startDate)
  //   const dtEndDate = new Date(endDate)
  //   const daysDiff = dateDiffInDays(dtEndDate, dtStartDate)
  //   if (isToday(dtStartDate)) {
  //     customDateFormat = `${t('global.today')}${
  //       daysDiff > 0 ? ` - ${formatLastUpdateDate(dtEndDate, getDateFormat2())}` : ''
  //     }`
  //   } else if (isTomorrow(dtStartDate)) {
  //     customDateFormat = `${t('global.tomorrow')}${
  //       daysDiff > 0 ? ` - ${formatLastUpdateDate(dtEndDate, getDateFormat2())}` : ''
  //     }`
  //   }
  //   return customDateFormat
  // }

  return (
    <Popup
      modal
      lockScroll
      open={showViewMixr}
      onClose={closeViewMixr}
      closeOnDocumentClick={false}
      position='top center'
      overlayStyle={{ background: 'rgba(54, 73, 88, 0.4)', padding: '2rem 0', overflowY: 'scroll' }}
      contentStyle={{
        width: '95%',
        maxWidth: '500px',
        padding: '0px',
        borderRadius: '22px',
        boxShadow: '5px 2px 10px 0 rgba(14, 11, 40, 0.15)',
        background: 'white',
        border: 'none'
      }}>
      <div className={styles.mixrPopupWrapper}>
        <div className={`${styles.header} ${styles.mixrHeader} ${styles[color]}`}>
          {isRecurrence && <Icon name='recurring-mixrs' styleModifier={styles.recurringIcon} />}
          <div
            className={styles.date}
            dangerouslySetInnerHTML={{ __html: getCustomDateFormat(startDate, endDate, utcOffset, t) }}
          />
          <div className={styles.time}>
            {`${convertUTCToTimezone(startDate, utcOffset, getTimeFormat1())} - ${convertUTCToTimezone(
              endDate,
              utcOffset,
              getTimeFormat1()
            )}`}{' '}
            <span>{timezone}</span>
          </div>
          {isVisibility && <Icon name='mask' styleModifier={styles.maskIcon} />}
          <div onClick={closeViewMixr} role='button'>
            <Icon name='close24' styleModifier={styles.closeIcon} />
          </div>
        </div>

        <div className={styles.body}>
          {picture ? (
            <img src={picture} alt={title} className={styles.image} />
          ) : (
            <img
              src={require('../../../assets/images/background-default-mixr.jpg')}
              alt={title}
              className={styles.image}
            />
          )}
          <h1 className={styles.title}>{title}</h1>
          <div className={styles.heading}>{t('global.aboutGroupMixr', { type: t('global.mixr') })}</div>
          <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
          <div className={styles.heading}>{t('myhome.mymixrs.datetime')}</div>
          <div className={styles.datetime}>
            <Icon styleModifier={styles.calendarIcon} name='calendar24' />
            <div>
              <div className={styles.date}>{`${convertUTCToTimezone(startDate, utcOffset, getDateFormat6())}`}</div>
              <div className={styles.time}>
                {`${convertUTCToTimezone(startDate, utcOffset, getTimeFormat1())} - ${convertUTCToTimezone(
                  endDate,
                  utcOffset,
                  getTimeFormat1()
                )}`}{' '}
                <span>({timezone})</span>
              </div>
            </div>
          </div>
          {userAttendance && (
            <div className={styles.heading}>
              {t('myhome.mymixrs.attendance', { type: t(`myhome.mymixrs.attendingType.${userAttendance}`) })}
            </div>
          )}
          {location && (
            <div className={styles.attendance}>
              <Icon styleModifier={styles.mapIcon} name='map24' />
              <div className={styles.location}>{location}</div>
            </div>
          )}
        </div>

        <div className={styles.footer}>
          <div role='button' className={styles.viewButton} onClick={handleClick}>
            {t('myhome.mymixrs.viewMixr')}
          </div>
          {!isMixrOver && isInvited && (
            <RSVP
              mixrId={mixrId}
              groupId={group?.id}
              groupName={group?.name}
              groupRole={group?.role}
              selectedUserAttending={userAttendance}
              groupAttending={group?.attending}
              mixrAttendingType={attendance}
              menuPortalTarget={menuPortalTarget}
              withoutGroupAproval={withoutGroupApproval}
              isInvite={isInvited}
              className={styles.rsvpButton}
              isRecurrence={isRecurrence}
            />
          )}
        </div>
      </div>
    </Popup>
  )
}

ViewMixrPopin.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  picture: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  isMixrOver: PropTypes.bool,
  color: PropTypes.string,
  timezone: PropTypes.string,
  utcOffset: PropTypes.string,
  location: PropTypes.string,
  isRecurrence: PropTypes.bool,
  isVisibility: PropTypes.bool,
  attendance: PropTypes.string,
  userAttendance: PropTypes.string,
  isInvited: PropTypes.bool,
  showViewMixr: PropTypes.bool,
  closeViewMixr: PropTypes.func,
  handleClick: PropTypes.func,
  handleRSVPChange: PropTypes.func
}

ViewMixrPopin.defaultProps = {
  isInvited: false,
  showViewMixr: false,
  isMixrOver: false,
  isRecurrence: false,
  isVisibility: false
}

export default ViewMixrPopin
